module.exports = __webpack_public_path__ + "static/media/003_g1_3 revised home.700f7acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/003_g1_3 revised home.png
// module id = 432
// module chunks = 0